/* eslint-disable */
import { cpf } from 'cpf-cnpj-validator';

export default {
  required: (value) => !!value || 'Campo obrigatório.',
  email: (value) => /.+@.+/.test(value) || 'E-mail inválido',
  cpf: (value) => !!cpf.isValid(value) || 'CPF inválido.',
}
